import React from "react"
import {Drawer, Form, Input, Row, Col, Select, Button, Switch} from "antd"
import {compose} from 'recompose';
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {bindActionCreators} from "redux";
import { sortBy } from 'lodash';
import * as SelectionActions from "../../reducers/selection_builder";
import PropTypes from "prop-types";

const {Option} = Select;

class SelectionCreationDrawer extends React.Component {

    onSubmit = () => {
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                this.props.history.push(`/selection/builder/createSelection`);
                this.props.insert(values);
                this.props.toggleVisibility()

            }
        })
    };


    static propTypes = {
        insert: PropTypes.func.isRequired
    };


    render() {
        const {visible, toggleVisibility, customers, type, form: {getFieldDecorator}} = this.props;
        console.log('scd', visible);
        return <Drawer title="New Selection" width={720} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Name">
                            {getFieldDecorator('name', {
                                rules: [{required: true, message: 'Please enter a Selection name'}],
                            })(<Input placeholder="Please enter a Selection name"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Customer">
                            {getFieldDecorator('customerCode', {
                                rules: [{required: true, message: 'Please select a customer'}],
                            })(
                                <Select placeholder="Customer"
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                    { sortBy(customers, ['name']).map((user) => (
                                        <Option value={user.code}>{user.name}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Type">
                            {getFieldDecorator('type', {
                                rules: [{required: true, message: 'Please select a type'}],
                            })(
                                <Select  placeholder="Type">
                                    {type.map((user) => (
                                        <Option value={user.id}>{user.description}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Active">
                            {getFieldDecorator('active', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(
                                <Switch/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button onClick={this.onSubmit} type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    populate: state.selection_builder.populate,
});

const mapDispatchToProps = dispatch => ({
    insert: bindActionCreators(SelectionActions, dispatch).getOverviewCreate,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(SelectionCreationDrawer);



// WEBPACK FOOTER //
// ./src/js/selection/create/SelectionCreationDrawer.js